/** Lykke's face: her photo from the cowork assets, or the purple "L" when it cannot load. */
import { useState } from 'react';
import { API_BASE_URL } from '@/cowork/omniad/api/coworkApi';

export const LYKKE_PHOTO = `${API_BASE_URL}/assets/avatars/lykke.png`;

export function LykkeAvatar({ size = 24, live }: { size?: number; live?: boolean }) {
  const [failed, setFailed] = useState(false);
  return (
    <span className="relative inline-grid shrink-0 place-items-center" style={{ width: size, height: size }}>
      {failed ? (
        <span className="grid h-full w-full place-items-center rounded-full bg-gradient-to-br from-[#be43ff] to-[#7a1fbf] font-bold text-white" style={{ fontSize: Math.max(10, size * 0.42) }}>L</span>
      ) : (
        <img src={LYKKE_PHOTO} alt="Lykke" onError={() => setFailed(true)} className="h-full w-full rounded-full object-cover" />
      )}
      {live && <span className="absolute -right-0.5 -top-0.5 h-2.5 w-2.5 animate-pulse rounded-full border-2 border-white bg-[#a9f600]" />}
    </span>
  );
}
